import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

/**
 * TipTap extension that strips `font-family` styles from HTML content on paste.
 * This ensures that copying text from external sources (e.g. Word, web pages)
 * does not override the template's configured font family.
 */
export const StripFontFamilyOnPaste = Extension.create({
  name: 'stripFontFamilyOnPaste',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('stripFontFamilyOnPaste'),
        props: {
          transformPastedHTML(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            doc.querySelectorAll<HTMLElement>('[style]').forEach((el) => {
              el.style.removeProperty('font-family');
            });
            return doc.body.innerHTML;
          },
        },
      }),
    ];
  },
});
